import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/cauchy/cdf';
import __var_2__ from '@stdlib/stats/base/dists/cauchy/ctor';
import __var_3__ from '@stdlib/stats/base/dists/cauchy/entropy';
import __var_4__ from '@stdlib/stats/base/dists/cauchy/logcdf';
import __var_5__ from '@stdlib/stats/base/dists/cauchy/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/cauchy/median';
import __var_7__ from '@stdlib/stats/base/dists/cauchy/mode';
import __var_8__ from '@stdlib/stats/base/dists/cauchy/pdf';
import __var_9__ from '@stdlib/stats/base/dists/cauchy/quantile';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace cauchy
*/
var cauchy = {};

/**
* @name cdf
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/cdf}
*/
setReadOnly( cauchy, 'cdf', __var_1__);

/**
* @name Cauchy
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/ctor}
*/
setReadOnly( cauchy, 'Cauchy', __var_2__);

/**
* @name entropy
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/entropy}
*/
setReadOnly( cauchy, 'entropy', __var_3__);

/**
* @name logcdf
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/logcdf}
*/
setReadOnly( cauchy, 'logcdf', __var_4__);

/**
* @name logpdf
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/logpdf}
*/
setReadOnly( cauchy, 'logpdf', __var_5__);

/**
* @name median
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/median}
*/
setReadOnly( cauchy, 'median', __var_6__);

/**
* @name mode
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/mode}
*/
setReadOnly( cauchy, 'mode', __var_7__);

/**
* @name pdf
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/pdf}
*/
setReadOnly( cauchy, 'pdf', __var_8__);

/**
* @name quantile
* @memberof cauchy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cauchy/quantile}
*/
setReadOnly( cauchy, 'quantile', __var_9__);


// EXPORTS //
export default cauchy;

export { __var_1__ as cdf, __var_2__ as Cauchy, __var_3__ as entropy, __var_4__ as logcdf, __var_5__ as logpdf, __var_6__ as median, __var_7__ as mode, __var_8__ as pdf, __var_9__ as quantile};